import styles from './card.module.scss';

export const Card = ({children, title, className = ''}) => (
  <div className={`${styles.card} ${className}`}>
    {title && <div className={styles.title}>{title}</div>}
    {children && <div className={styles.content}>{children}</div>}
  </div>
);
